import useAuthFromUrl from '@/redux/hooks/useAuthFromUrl';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const GuestRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('auth_token');
  useAuthFromUrl();

  if (token) {
    // Redirect to home page if user is authenticated
    return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default GuestRoute;
